<template>
<a
	:href="link"
	class="job-board-card"
	v-on:mouseover="mouseOver"
	v-on:mouseleave="mouseLeave"
>

	<div class="job-board-card__label">
		<p>{{ headline }}</p>
	</div>

	<div class="job-board-card__vacancy">
		<h2 v-for="title in titles" :key="title">{{ title }}</h2>
	</div>

	<div class="job-board-card__cta">
		<p>{{readmore}}
			<svg
				version="1.1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink"
				x="0px"
				y="0px"
				viewBox="150 410 300 70"
				style="enable-background:new 150 410 300 70;" xml:space="preserve"
				:class="[isHovered ? 'animate' : '']"
			>
			<polygon
				class="st0"
				points="435.7,445.5 406.8,416.6 406.8,442.3 162.8,442.3 162.8,448.8 406.8,448.8 406.8,474.5 "
			/>
			</svg>
		</p>
	</div>

</a>
</template>


<script>
export default {
	name: 'JobBoardCard',
	components: {},
	props: {
		headline: String,
		titles: Array,
		link: String,
		readmore: String
	},
	data() {
		return {
			isHovered: false
		}
	},
	methods: {
		mouseOver() {
			this.isHovered = true
		},
		mouseLeave() {
			this.isHovered = false
		}
	}
}
</script>


<style scoped lang="scss">
@import "../scss/globals.scss";

@keyframes arrowAnimation {
    0% {}
    10% {
        opacity: 0;
        transform: translateX(0%);
    }
    11% {
        transform: translateX(-100%);
    }
    100% {}
}

.job-board-card {
	width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: $margin2-1 0;
	text-align: center;

	flex: 1;

    background-color: $color-dark-grey;

    &__label {
        text-transform: uppercase;
        letter-spacing: 0.2em;
		font-size: $font-size-xxs;
		@media screen and (min-width: 1025px) {
			font-size: $font-size-xs;
		}
    }

    &__vacancy {
        font-family: $font-expanded;
		font-size: $font-size-s;
        margin: 1rem 0 2rem;
		@media screen and (min-width: 1025px) {
			font-size: $font-size-m;
		}

        h2 {
            line-height: 1.2;
        }
    }

    &__cta {
        position: relative;
        font-family: $font-expanded;
		font-size: $font-size-xxs;
		margin: 0;
        padding-top: 0.4em;

        overflow: hidden;
        @media screen and (min-width: 769px) {
			margin-top: 1.2em;
			font-size: $font-size-xs;
        }
    }

    svg {
        transition: transform 0.6s $ease-in-out;
        transform-origin: left;
        margin-bottom: -.1em;
        margin-left: 0.5em;
        height: 0.8em;
        fill: currentColor;

        &.animate {
            polygon {
                animation: arrowAnimation 1s forwards $ease-in-out;
            }
        }
    }
}
</style>
